import * as React from "react"
import { DropTarget } from "react-dnd-legacy"
import { NativeTypes } from "react-dnd-html5-backend-legacy"

type Props = {
    children: React.ReactNode
    disabled?: boolean
}

type ConnectedProps = Props & {
    connectDropTarget: (element: React.ReactElement) => React.ReactElement
}

const ReactDndFileDropTarget = DropTarget(
    NativeTypes.FILE,
    { canDrop: (props: Props) => !props.disabled },
    connect => ({
        connectDropTarget: connect.dropTarget(),
    })
)(({ connectDropTarget, children }: ConnectedProps) => connectDropTarget(<div>{children}</div>))

class NativeFileDropTarget extends React.Component<Props> {
    static contextTypes = { dragDropManager: () => null }
    declare context: { dragDropManager?: unknown }

    render() {
        if (!this.context.dragDropManager) {
            return this.props.children
        }
        return <ReactDndFileDropTarget disabled={this.props.disabled}>{this.props.children}</ReactDndFileDropTarget>
    }
}

export default NativeFileDropTarget
